"use client";

import Button from "../ui/Button";
import { SEGMENTED_TRACK, segmentClasses } from "../ui/segmented";

interface FulfillmentToggleProps {
  mode: "pickup" | "delivery";
  onModeChange: (mode: "pickup" | "delivery") => void;
  disabled?: boolean;
  /** Extra classes on the track, e.g. `w-full` inside the entry modal. */
  className?: string;
}

/* Segmented pill toggle, styled from ui/segmented so the price filter on a
   product row stays identical to it. */

export default function FulfillmentToggle({
  mode,
  onModeChange,
  disabled = false,
  className = "",
}: FulfillmentToggleProps) {
  return (
    <div
      className={`${SEGMENTED_TRACK} transition-opacity duration-150 ${
        disabled ? "opacity-60" : ""
      } ${className}`}
      aria-busy={disabled}
    >
      <Button
        raw
        type="button"
        onClick={() => onModeChange("pickup")}
        disabled={disabled}
        aria-pressed={mode === "pickup"}
        data-no-lift
        className={segmentClasses(mode === "pickup")}
      >
        Pickup
      </Button>
      <Button
        raw
        type="button"
        onClick={() => onModeChange("delivery")}
        disabled={disabled}
        aria-pressed={mode === "delivery"}
        data-no-lift
        className={segmentClasses(mode === "delivery")}
      >
        Delivery
      </Button>
    </div>
  );
}
